import type { RentalRoomRow, RentalSiteRow } from '../rental-resource-selector-modals.tsx'

export function formatSiteAddress(site?: RentalSiteRow, room?: RentalRoomRow) {
  if (!site) {
    return ''
  }
  return [site.provinceName, site.cityName, site.districtName, site.detailAddress, room?.roomNo]
    .filter(Boolean)
    .join(' ')
}

export function rentalResourceLabels({
  batch,
  businessId,
  occupancyMode,
  site,
  room
}: {
  batch: boolean
  businessId?: number
  occupancyMode?: string
  site?: RentalSiteRow
  room?: RentalRoomRow
}) {
  let button = '请先选择租赁业务'
  let label = '租赁地址'
  let hint = '注册地址可仅选择场地，也可指定房间。'
  let selection = ' · 仅使用地址'
  if (businessId) button = site ? '更换场地或房间' : '选择场地与房间'
  if (occupancyMode === 'physical') {
    label = '租赁地址与房间'
    hint = '实际入驻需选择一个可用房间。'
  }
  if (room) selection = ` · ${room.roomNo}`
  if (batch) {
    if (businessId) button = site ? '更换租赁地址' : '选择租赁地址'
    label = '租赁地址'
    hint = '每个订单自动分配一个不同房间，房源不足时不创建订单。'
    selection = ' · 自动分配房间'
  }
  return { button, label, hint, selection }
}
